import { useFormikContext } from "formik";
import * as Yup from "yup";
import { Stack, Typography } from "@mui/material";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";

export const DateFormSchema = Yup.object().shape({
  date: Yup.string().required("Campo requerido"),
});

export type IDateForm = {
  date: Date | null;
};

export const dateFormInitialValues: IDateForm = {
  date: null,
};

export const dateFormFields = Object.keys(dateFormInitialValues);

export const onSubmitLocationForm = async () => {
  return;
};

const DateForm = () => {
  const formik = useFormikContext<IDateForm>();

  return (
      <Stack spacing={3} alignItems="center">
        <Typography textAlign="center" variant="h4">¿Que día agendamos<br/>tu reserva?</Typography>
        <DateCalendar
          value={formik.values.date}
          views={['day']}
          onChange={(value) => {
            formik.setFieldValue('date', value);
          }}
        />
      </Stack>
  );
};

export default DateForm;
